<template>
  <div class="voteback">
		<span class="Chakan" @click="CKList()">查看投票结果</span>
    
		<div class="login">
			<van-dialog v-model="show1" confirmButtonText="" >
				<div style="padding: 24px 0 0 0;text-align: center; font-size: 14px; width: 100%;">
					<div>由于您未关注“数聚智连”微信公众号，无法投票。</div>
					<div>请关注微信公众号，见下方二维码。</div>
				</div>
        <img src="../assets/img/erweima.jpg" class="erweima"></img>
				<!-- <van-cell-group>
					<van-field class='colo' v-model="phone" label="手机号" type="number" required clearable />
					<van-field class='colo' v-model="verifyCode" center clearable label="验证码" placeholder="请输入短信验证码" required>
						<van-button v-show="show" id="sms" slot="button" size="small" type="info" @click='smsbtn'>发送验证码</van-button>
						<van-button v-show="!show" disabled id="sms2" slot="button" size="small" type="info" @click='smsbtn'>{{count}}s</van-button>
					</van-field>
				</van-cell-group> -->
			</van-dialog>

      
			<van-dialog v-model="show2" confirmButtonText="" >
				<div style="padding: 24px 0 0 0;text-align: left; font-size: 14px; width: 100%;">
					<div>投票规则：</div>
					<div>1、你最pick谁，就投票给谁</div>
					<div>2、投票时间段为10月16日15点-11月9日24点</div>
					<div>3、投票分为2个阶段：</div>
					<div>10月16日-10月19日：不能投给自己所在队伍</div>
					<div>10月20日-11月9日：上传团队在舞台区的合影，可投票给自己队伍</div>
					<div>4、投票结果将在11月2日，11月10日，两个时间点公布</div>
				</div>
			</van-dialog>
		</div>
    
    <div class="contentDiv">
      <img src="../assets/img/mobel/top.png" class="Imgtop"></img>
      <img src="../assets/img/mobel/bot.png" class="Imgbot"></img>
      <van-radio-group v-model="result" :max="2" id="contentDiv">
        <van-radio @click="onChange" v-for="(item, index) in prolistdata" :name="item.id">{{item.title}} 
        <!-- <span style="color: #a67d56;" v-if="item.programVotes!=0">{{item.programVotes}}</span>  -->
        <img
        slot="icon"
        slot-scope="props"
        :src="props.checked ? require('../assets/img/sasa.png') : require('../assets/img/asas.png')">
        </van-radio>
      </van-radio-group>
  <!-- 仿写滚动条 -->
      <!-- <div id='ScrollStyle'>
        <img src="../assets/img/mobel/scrollS.png" id="scrollS"

        :style="'top:'+((ScrollBfb>=0&&ScrollBfb<=90)?ScrollBfb:'')+'%'"></img>
      </div> -->
      <!-- <van-radio-group :value="radio" bind:change="onChange">
        <van-radio name="1">单选框 1</van-radio>
        <van-radio name="2">单选框 2</van-radio>
      </van-radio-group> -->

		<div class="JieSend">
			<div class="votebtn"  @click='programvot'></div>
		</div>
		<span class="GuiZe" @click="show2=true">投票规则</span>

    </div>
		<!-- <span class="jieOver">还可以选择{{2-kexuan}}个队伍</span> -->
		<!-- <span class="jieOver">最多可选择3个队伍</span> -->
    <img src="../assets/img/mobel/yunbottom.png" class="yunbottom"></img>
    <img src="../assets/img/mobel/title.png" class="title"></img>
    <img src="../assets/img/mobel/titleShare.png" class="title TitleShare"></img>
		
		<div class="qdsucceedB" v-if="qdsucceedShow">
		  <img src="../assets/img/rolesuc.png" class="qdsucceed">
		</div>
		
  </div>
  
  
</template>

<script>

import Vue from 'vue';
import { Checkbox,Radio,RadioGroup,CheckboxGroup,Cell,CellGroup,Button,Dialog,Notify,Field,Toast} from 'vant';

Vue.use(Notify).use(Dialog).use(Button).use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(Radio).use(RadioGroup).use(Field).use(Toast);
export default {
  name: 'HelloWorld',
  data () {
    return {
      txt: '发送验证码',
      show: true,
      show1:false,
      show2:false,
      phone: "",
      count: '',
      verifyCode: "",
      radio:'',
      result:[],
      prolistdata:"",
      program:[{Check:false,},{Check:false,},{Check:false,},{Check:false,},{ Check:false, }],
      kexuan:0,
      checked: true,
      qdsucceedShow:false,
      falg:true,
      ScrollBfb:0,
      ListisShow:false,


      positionX:0,
      positionY:0,
    }
  },
  
	computed:{
		userID(){
			return localStorage.getItem("userid");//用户id
		}
	},
  methods: {
    
      programvot(){
        if(this.falg){
          this.falg = false
          var that = this
        if(this.result.length==0){
          Toast.fail('未选择队伍');
          // Notify({ type: 'warning', message: '未选择队伍' })
        }else{
          console.log(this.result)
          // let new_arr = this.result.join(",");
          let new_arr = this.result;
		  // alert(this.userID)
          this.axios.post('https://party.blueiec.com/annual-meeting/qyactivityvoterecord/save',
          {
            'activityId':2,
            'userId':this.userID,
            // 'userId':18531807559,
            
            'teamId':new_arr
            })
          .then(res=> {
            if(res.data.code==0){
              that.qdsucceedShow = true;
              setTimeout(function() {
                that.qdsucceedShow = false;
              }, 2000);
            }else{
              Toast.fail(res.data.msg);
              // Notify({ type: 'warning', message: res.data.msg })
              this.result=[]
              this.meetprolist()
            }
          })
        }
        setTimeout(function(){
          that.falg = true				
        },2000)
      }
      },
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
      },
      onChange(event) {
        
      },
      Check(data){
        console.log(1232)
        var a = 0;
        for(var i in this.program){
          if(this.program[i].Check==true){
            a++;
          }
        }
        if(this.program[data].Check==false){
          if(a<2){
            this.program[data].Check = true
          }else{
            // alert('最多可选两个队伍')
          }
        }else if(this.program[data].Check==true){
          this.program[data].Check = false
        }
        
        this.kexuan=0;
        for(var i in this.program){
          if(this.program[i].Check==true){
            this.kexuan++;
          }
        }
      },
    meetprolist(){
      this.axios.post('https://party.blueiec.com/annual-meeting/qyactivityteam/queryTeam',{'activityId':2})
      .then(res=> {
        this.prolistdata = res.data.list
        this.ListisShow = res.data.isShow
      })
    },

			smsbtn() {
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}
				this.axios.get('https://party.blueiec.com/annual-meeting/qy/verifyCode?phone=' + this.phone)
					.then(res => {
						console.log(res)
            Toast(res.data.msg);
						// Notify({
						// 	type: res.data.code == 0 ? 'success' : 'danger',
						// 	message: res.data.msg
						// })
					})
			},
			beforeClose(action, done) {
				var that = this
				if (action === 'confirm') {
					this.axios.get('https://party.blueiec.com/annual-meeting/qy/phoneLogin?phone=' + this.phone + '&verifyCode=' +
							this.verifyCode + '&activityId=2')
						.then(res => {
							console.log(res)
							if (res.data.code == 0) {
                Toast.success(res.data.msg);
								// Notify({
								// 	type: 'success',
								// 	message: res.data.msg
								// })
								localStorage.setItem("userid", res.data.user.userid); //用户id
								localStorage.setItem("username", res.data.user.name); //获取用户头像
								localStorage.setItem("signTime", res.data.user.signTime); //获取用户头像
								this.qdsucceedShow = true;
								setTimeout(() => {
									this.qdsucceedShow = false;
								}, 1500);
								done()
							} else {
                Toast.fail(res.data.msg);
								// Notify({
								// 	type: 'danger',
								// 	message: res.data.msg
								// })
								done(false)
								this.verifyCode = ''
							}
						})
				} else {
					done();
				}
			},

			getToken(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        let box = document.getElementById('contentDiv')
        this.ScrollBfb = (box.scrollTop / (box.scrollHeight-box.offsetHeight))*85
    },
    CKList(){
      if(this.ListisShow==false){
        Toast('投票结果暂未开放');
      }else{
        this.$router.push('/rule')
      }
    },
    // 拖拽div
    

  },
  mounted(){
        // alert(this.userID)
    this.meetprolist()
    
    var box = document.getElementById('contentDiv')
    var $this = this
    // 监听这个dom的scroll事件
    box.onscroll  = () => {
      console.log('on scroll')
      $this.handleScroll()
    }



      function IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
      }

  // 如果是PC那么就不微信验证
      if(!IsPC()){
      // if(false){
              // var code = this.getToken('code');
              // if (code) {
              //     this.axios.get('https://party.blueiec.com/annual-meeting/qy/sign?code=' + code + '&activityId=2')
              //       .then(res => {
              //         // alert(JSON.stringify(res.data))
              //         if (res.data.code == 0) {
              //           localStorage.setItem("userid", res.data.user.userid); //用户id
              //           localStorage.setItem("username", res.data.user.name); //获取用户头像
              //           localStorage.setItem("signTime", res.data.user.signTime); //获取用户头像
              //           // this.qdsucceedShow = true;
              //           // setTimeout(() => {
              //           // 	this.qdsucceedShow = false;
              //           // }, 1500);
              //         } else {
              //           this.show1 = true;
              //         }
              //       })

              // } else {
              //   this.axios.get('https://party.blueiec.com/annual-meeting/qy/getUserCode')
              //     .then(res => {
              //       if (res.data.url) {
              //         window.location.replace(res.data.url)
              //       }
              //     })
              // }
      }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.voteback{
  position: absolute;
  top:0;left:0;
  width:100%;
  
  box-sizing: border-box; 
  height: calc(100vh); 
  background: 
              url('../assets/img/mobel/bg2.png') no-repeat center bottom,
              url('../assets/img/mobel/bg1.jpg') no-repeat center top;
  background-size: 100% auto;
  overflow: hidden;
  z-index: 0;
}
.votebtn{
  width:3.5rem; 
  height:1rem;
  background: url('../assets/img/mobel/votebtn.png'); 
  background-size: 100% 100%;
  margin: 0 auto;
}
.contentDiv{
  padding:0.4rem;
  box-sizing: border-box;
  background: url('../assets/img/mobel/bat.png') repeat center ;
  background-size:100% auto;
  position: absolute;
  width: 75%; 
  height: 60%;
  left: 0;
  right: 0;
  bottom: 5%;
  margin: auto;
}
.voteback .van-radio__label{font-size: 14px; font-weight: 900; color: #a67d56;margin-top: 0.05rem;}
.voteback .van-radio{
  padding-bottom: 0.2rem;
  }
.voteback .van-radio-group{
  overflow: scroll;
  position: absolute;
  display: inline-block;
  width: 80%;
  height: 68%;
  left: 0.5rem;
  top: 10%;
  padding-right: 0.5rem;
  margin: auto;
  z-index: 200;
  box-sizing: border-box;
  }
.voteback .van-radio__icon img{
  width: 0.5rem; 
  height: 0.5rem;
  padding: 0.08rem;
  box-sizing: border-box;
}
/* .van-button{
	background: url('../assets/img/btnbg.png');
	background-size: cover;
	border: 1px solid transparent;
} */
.qdsucceedB{
  display: block;
  height: 100vh;
  background: rgba(0,0,0,0.7);
  background-size: auto 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin:auto;
  z-index: 500;
  animation: qdCg1 2.5s forwards;
  -moz-animation: qdCg1 2.5s forwards;	/* Firefox */
  -webkit-animation: qdCg1 2.5s forwards;	/* Safari 和 Chrome */
  -o-animation: qdCg1 2.5s forwards;	/* Opera */
}
.qdsucceed{
  display: block;
  height: 40%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin:auto;
 
}

@keyframes qdCg1
{
0%   {opacity:0;}
70%  {opacity:1;}
100% {opacity:0;}
}

@-moz-keyframes qdCg1 /* Firefox */
{
0%   {opacity:0;}
70%  {opacity:1;}
100% {opacity:0;}
}

@-webkit-keyframes qdCg1 /* Safari 和 Chrome */
{
0%   {opacity:0;}
70%  {opacity:1;}
100% {opacity:0;}
}

@-o-keyframes qdCg1 /* Opera */
{
0%   {opacity:0;}
70%  {opacity:1;}
100% {opacity:0;}
}

.jie{
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
  justify-content: space-between;
  height:0.8rem;
  width: 94%;
  margin-left: 3%;
  line-height:0.8rem;
  font-size: 0.26rem;
  border-bottom:  1px solid #efefef;
  box-sizing: border-box;
  
}
.jieT{
  text-align: left;
  flex-grow:1;
  color: #0068b6;
}
.jieC{
  text-align: right;
  flex-grow:3;
  color: #999;
}
.jieOver{
  display: block;
  color: #f29600;
  height:1rem;
  width: 94%;
  margin-left: 3%;
  line-height:1rem;
  font-size: 0.26rem;
  text-align: right;
}

.JieSend{
  position: absolute;
	width: 80%;
  height: 1rem;
  bottom: 8%;
  left: 0;
  right: 0;
  margin: auto;
}

/* 滚动条样式 */
.van-radio-group::-webkit-scrollbar {/*滚动条整体样式*/
    /* width: 0px;     高宽分别对应横竖滚动条的尺寸 */
    /* height: 0px;
    border-radius: 1rem;
    overflow: auto;
    margin-right: 0.3rem; */
}
.van-radio-group::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    /* border-radius: 1rem;
    background:#00153b;
    width: 0.6rem;
    background: url('../assets/img/mobel/scrollS.png') no-repeat center top;
    background-size: 100% auto; */
}
.van-radio-group::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 1px  1px 0 rgba(0,0,0,0.2); 
    /*border-radius: 10px;*/
    /* background: url('../assets/img/mobel/scroll.png') no-repeat center;
    background-size: 100% 100%;
    border-radius: 1rem;
    width: 1px; */
}
.JieSend span{
	text-align: center;
	background: #0068b6;
	color: #fff;
	display: inline-block;
	width: 3rem;
	height: 0.8rem;
	line-height: 0.8rem;
	font-size: 0.28rem;
	border-radius: 0.2rem;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
} 
.Imgbot{
  display: inline-block;
  width: 120%;
  position: absolute;
  bottom: -0.3rem;
  left: -10%;
  right: 0;
  margin: auto;
}
.Imgtop{
  display: inline-block;
  width: 120%;
  position: absolute;
  top: -0.3rem;
  left: -10%;
  right: 0;
  margin: auto;
}
.yunbottom{
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  pointer-events: none;
}
.title{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
}

.TitleShare{
  animation: ShareMove 2s ease-in-out infinite alternate;
  -moz-animation: ShareMove 2s ease-in-out infinite alternate;	/* Firefox */
  -webkit-animation: ShareMove 2s ease-in-out infinite alternate;	/* Safari 和 Chrome */
  -o-animation: ShareMove 2s ease-in-out infinite alternate;	/* Opera */
}
@keyframes ShareMove
{
0%   {opacity:0;}
100% {opacity:1;}
}

@-moz-keyframes ShareMove /* Firefox */
{
0%   {opacity:0;}
100% {opacity:1;}
}

@-webkit-keyframes ShareMove /* Safari 和 Chrome */
{
0%   {opacity:0;}
100% {opacity:1;}
}

@-o-keyframes ShareMove /* Opera */
{
0%   {opacity:0;}
100% {opacity:1;}
}
#ScrollStyle{
  display: inline-block;
    width: 1rem;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 60%;
    background: url('../assets/img/mobel/scroll.png') no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 10%;
    right: 0.3rem;
    z-index: 201;
    pointer-events: none;
}
#scrollS{
  position: absolute;
  width: 1rem;
  top: 0;
  left: 0;
  right: 0%;
}

	.login .van-field__label {
		width: 60px !important;
	}

	.login .van-button {
		/* background: #fff !important; */
	}

	.login .colo {
		color: #000 !important;
	}
	.login .van-cell-group {
		margin-top: 0.4rem;
	}
  .erweima{
    display: inline-block;
    width: 100%;
  }
  .Chakan{
    display: block;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    color: #efefef;
    z-index: 800;
    font-size: 0.26rem;
    text-align: center;
    padding: 0.05rem 0;
  }
  .GuiZe{
    display: block;
    color: #4f4f4f;
    z-index: 800;
    font-size: 0.26rem;
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 3%;
    left: 0;
    right: 0;
    padding: 0.05rem 0;
  }
  .van-dialog{
      background-color: rgba(0,0,0,0.0) !important;
      background: 
        url('../assets/img/mobel/top.png') no-repeat center top,
        url('../assets/img/mobel/bot.png') no-repeat center bottom,
        url('../assets/img/mobel/bat.png') repeat-y center center;
      background-size: 100% auto,100% auto,80% auto;
      padding: 0.5rem 1rem;
      box-sizing: border-box;
      border-radius: 0;
      color: #663924 !important;
      z-index: 999999;
  }
  .van-button__content{
    font-size: 0px !important;
      background: url('../assets/img/mobel/alertQD.png') no-repeat center top !important;
      background-size: 80% auto !important;
      
  }
  .van-dialog__confirm{
    background-color: rgba(0,0,0,0);
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  .van-button::before{
    border-color:  rgba(0,0,0,0) !important;
    background-color: rgba(0,0,0,0) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/choose.vue